import { IPageOption } from './ui';

export interface IContent {
  id: number;
  organizationId: number | null;
  title: string;
  subTitle: string;
  description: string;
  data: string;
  thumbnailUrl: string;
  type: ContentType;
  createdAt: string;
  updatedAt: string;
  jsonUpdatedAt?: Date;
}

export enum ContentType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  NONE = 'NONE',
  EVENT_DETAIL = 'EVENT_DETAIL',
}

export type SearchContentsFilterType = Partial<Pick<IContent, 'title'>>;
export type SearchContentsQueryType = IPageOption & SearchContentsFilterType;

export type ContentsModuleType =
  | 'MAIN_IMAGE'
  | 'SUB_IMAGE'
  | 'TITLE'
  | 'SUB_TITLE'
  | 'TEXT'
  | 'BUTTON';

export interface IContentsModule {
  id: number;
  type: ContentsModuleType;
  data: string;
  backgroundColor?: string;
}

export interface IButtonContentsModule extends IContentsModule {
  link: string;
}

export type ContentsPageType = 'LIST' | 'COLLECTION_MODAL' | 'EVENT_MODAL';
